import PaymentProcessor from "../../../../../components/payment/PaymentProcessor";
import {useState} from "react";
import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import Dialog from "../../../general/dialog/Dialog";
import Popup from "../../../../../components/general/popup/Popup";
import DialogTitle from "../../../general/dialog/DialogTitle";
import DialogMessage from "../../../general/dialog/DialogMessage";
import DialogButtonContainer from "../../../general/dialog/DialogButtonContainer";
import DialogButton from "../../../general/dialog/DialogButton";
import useSession from "../../../../services/state/session/useSession";
import {useSelector} from "react-redux";
import errorReportRequest from "../../../../services/rest/request/error/errorReportRequest";

const getPaymentErrorMessage = (paymentResult, paymentError) => {
    if(paymentResult && paymentResult.declined) {
        return ["Payment Declined", "We could not accept payment. Please try a different payment method"]
    } else if(paymentError) {
        try {
            void reportUnrecognisedPaymentMessage(paymentError);
        } catch (e) {}
        return ["Payment Issue", "Message from the server: " + paymentError]
    }
}


const reportUnrecognisedPaymentMessage = async (response) => {
    void errorReportRequest()
        .tag("Unrecognised Checkout Error Message")
        .message(JSON.stringify(response))
        .url("payment")
        .sendIt(1);
}

const CartPaymentProcessor = () => {

    const { sessionData : session } = useSession();
    const [error, setError] = useState(null);
    const { paymentResult, error: paymentError } = useSelector(
        state => state.session.payment
    );
    const errorMsg = getPaymentErrorMessage(paymentResult, paymentError);
    useValueChangeListener(() => setError(errorMsg), [errorMsg]);

    return (
        <>
            {error &&
                <Popup>
                    <Dialog>
                        <DialogTitle>{error[0]}</DialogTitle>
                        <DialogMessage>{error[1]}</DialogMessage>
                        <DialogButtonContainer>
                            <DialogButton
                                onClick={() => setError(null)}
                            >
                                OK
                            </DialogButton>
                        </DialogButtonContainer>
                    </Dialog>
                </Popup>
            }
            <PaymentProcessor session={session} />
        </>
    )
}

export default CartPaymentProcessor;
